import React, { useState, useEffect } from 'react';
import { Form, Input, Row, Col, Button } from 'antd';
import { ButtonGroup } from 'components/molecules';

interface FormItemProps {
  info: LectureInfoDto|undefined;
  type: string;
  onMemoUpdate: (params: B2cInfoSaveReqDto) => void;
}

const LectureInfoForm = ({info, type, onMemoUpdate}: FormItemProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */
  const [form] = Form.useForm();
  const { TextArea } = Input;
  /* ======================================================
  * hooks
  * ====================================================== */

  /* ======================================================
  * events
  * ====================================================== */  

  const onSubmit = (e) => {
    if (info)
      onMemoUpdate({id: info.id, memo: e.memo})
  };

  useEffect(() => {
    if (!!info)
    form.setFieldsValue({
        memo: info.memo || '',
    });
}, [info]);  
  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <div className={'custom-modal'}>
      <Form
        form={form}
        name="ProjectInfo"
        layout="horizontal"  
        labelCol={{ flex: '120px' }}
        onFinish={onSubmit}
        style={{width:'100%'}}
        autoComplete="off"
      >
        <Row>
            <Col span={12}>
            <Form.Item label={'과정명'}>
                <label>{info?.lecture_title}</label>                  
            </Form.Item> 
            </Col> 
            <Col span={12}> 
            <Form.Item label={type==='pml'?'진단기간':'기간'}>
                <label>{info?.start_date} ~ {info?.end_date}</label>                  
            </Form.Item>   
            </Col>            
        </Row> 
        {(type !== 'pml') && (
        <Form.Item label={'장소'}>
            <label>{info?.lecture_place}</label>                  
        </Form.Item>   
        )}
        {(type !== 'seminar') && (
        <Row>
            <Col span={12}>
            <Form.Item label={'총매출액'}>
                <label>{info?.max_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+' 원 '} {'(vat포함: '+(info?info.max_price*1.1:0).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+')'}</label>                  
            </Form.Item> 
            </Col> 
            <Col span={12}> 
            <Form.Item label={type==='pml'?'진단비':'단가'}>
                <label>{info?.lecture_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</label>                  
            </Form.Item>   
            </Col>            
        </Row> 
        )}
        <Form.Item name='memo' label={'메모'}>
          <TextArea rows={3} placeholder='메모를 입력하세요'/>   
        </Form.Item>                                       
        <Button htmlType="submit"  type="primary" style={{margin:"10px 0px", float:"right"}}>{'메모저장'}</Button>
      </Form>
    </div>
    
  );
};

export default LectureInfoForm;
